/** String helpers **/

// Convert to sentence case
export function toSentenceCase(input: string, locale?: string): string {
  if (!input) return "";
  const lower = locale ? input.toLocaleLowerCase(locale) : input.toLowerCase();
  return lower.charAt(0).toUpperCase() + lower.slice(1);
}
